import { CheckoutSubmitReq, CheckoutSubmitRes } from '@/types/checkout';
import { http } from './http.service';
import { trimAll } from '@/app/utils';
import { invoiceToEmailsType } from '@/types/user';

class CheckoutService {
  checkoutSubmit = async (checkoutSubmitReq: CheckoutSubmitReq) => {
    const response = await http.post<CheckoutSubmitRes>(`/api/checkout/submit`, trimAll(checkoutSubmitReq));
    return response;
  };

  getCheckoutOneTimeCode = async () => {
    const response = await http.get(`/api/checkout/code`);
    return response;
  };

  getCheckoutPONumber = async () => {
    const response = await http.get(`/api/checkout/genPoNumber`);
    return response;
  };

  getCheckoutInvoiceEmail = async () => {
    const response = await http.get(`api/user/getLocalInvoiceEmail`);
    return response;
  };

  updateEmailAddress = async (emails: invoiceToEmailsType) => {
    const response = await http.post(`/api/user/saveLocalInvoiceEmail`, emails);
    return response;
  };
}

export const checkoutService = new CheckoutService();
